import React from "react";
import { Helmet } from "react-helmet";

const SEO = () => {
  return (
    <Helmet>
      <html lang="en" />
      <title>
        CloudLogic IT Solutions | Microsoft Cloud Transformation Partner
      </title>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta
        name="description"
        content="CloudLogic IT Solutions helps Australian organisations implement, optimise, secure and govern Microsoft 365, Azure, SharePoint, Teams, automation and compliance-ready cloud environments."
      />
      <meta
        name="keywords"
        content="Microsoft 365 consultant, Microsoft cloud transformation, SharePoint implementation, Teams implementation, Azure support, Microsoft 365 security, governance, compliance readiness, Melbourne IT consultant"
      />
      <meta name="author" content="CloudLogic IT Solutions" />

      <meta
        property="og:title"
        content="CloudLogic IT Solutions | Microsoft Cloud Transformation Partner"
      />
      <meta
        property="og:description"
        content="Implement, optimise, secure and govern Microsoft 365, Azure, SharePoint, Teams, automation and compliance-ready cloud environments."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://cloudlogicit.com.au/" />
      <meta
        property="og:image"
        content="https://cloudlogicit.com.au/og-image.jpg"
      />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="CloudLogic IT Solutions" />
      <meta
        name="twitter:description"
        content="Microsoft cloud transformation, SharePoint, Teams, Azure, security, governance, automation and compliance-ready cloud support."
      />
      <meta
        name="twitter:image"
        content="https://cloudlogicit.com.au/og-image.jpg"
      />

      <link rel="canonical" href="https://cloudlogicit.com.au/" />
    </Helmet>
  );
};

export default SEO;
